import styles from "./YuJaToggle.module.css";
import {useEffect, useRef, useState} from "react";
import {BUTTON, DISABLED_TEXT, ENABLED_TEXT} from "../../utils/constants";
import {YuJaTooltip} from "./YuJaTooltip";


export const YuJaToggle = ({
                               toggled=false,
                               ariaLabel,
                               onClick,
                               label=true,
                               disabled=false,
                               disabledReason,
                               enabledText="",
                               disabledText="",
                               containerStyle={},
                               ...props
}) => {
    const [inputVal, setInputVal] = useState(toggled);
    const actualInputBoxRef = useRef(null);
    const onClickEvent = (e) => {
        if (disabled) {
            return
        }

        const box = actualInputBoxRef.current;
        if (box) {
            box.click();
        }
    }

    const onChangeFunc = (e) => {
        // setInputVal(e.target.checked);
        if (onClick) {
            onClick(e);
        }
    }

    useEffect(() => {
        setInputVal( toggled);
    }, [toggled]);

    return (
        <div className={styles.container} style={containerStyle}>
            {!!label &&
                <span className={styles.label}>
                    {!!inputVal
                        ? (!!enabledText ? enabledText : ENABLED_TEXT)
                        : (!!disabledText ? disabledText : DISABLED_TEXT)
                    }
                </span>
            }

            <div
                tabIndex={disabled ? -1 : 0}
                className={styles.toggleContainer}
                onClick={onClickEvent}
                role={BUTTON}
                {...props}
            >
                <input ref={actualInputBoxRef} name={props.name} className={styles.actualCheckBox} type={"checkbox"}
                       aria-label={ariaLabel}
                       checked={inputVal} onChange={onChangeFunc} disabled={disabled}/>
                <span className={styles.backgroundWrapper}/>
            </div>
        </div>

    )
}